const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Section = require("../../../components/global/components/Section.js");
const Label = require("../../../components/global/components/Label.js");
const Button = FuzzyReaction.Components.Global.Button;
const Column = Form.Column;
const Row = Form.Row;
const FormStore = FuzzyReaction.Stores.FormStore;
const EmailMessagesStore = require('../../../stores/EmailMessagesStore');
const CohortsStore = require('../../../stores/CohortsStore');
const DayTimePicker = require("../../../components/global/components/DayTimePicker.js");
const Scheduling = require('../Scheduling');
const Status = require('../Status');
const _ = require("lodash");
const Modal = FuzzyReaction.Components.Global.Modal;
const EmailMessagesApi = require('../../../api-utils/EmailMessagesApi');

const EmailManagement = createReactClass({
    displayName: 'EmailManagement',

    defaultSendTestEmail: 'doug@cardiocast.app',

    getInitialState: function () {
        return {
            previewHtml: '',
            workingResource: {
                channel: 'email',
                scheduling: Scheduling.ONCE_NOW,
                show_unsubscribe: 1,
                cohort: null,
                allow_duplicate_sends: 0,
                stop_behavior: 'never'
            },
            openSendTestModal: false,
            sendTestResource: {
                recipient_email: this.defaultSendTestEmail
            },
            saving: false,
            savingForSendTest: false
        }
    },

    resourceActions: new ResourceActions('email-messages'),
    cohortsResourceActions: new ResourceActions('cohorts'),
    cohortsTypeAheadResourceActions: new ResourceActions('cohorts'),

    /**
     * Edit email form key
     */
    formKey: 'emailForm',

    /**
     * Send test email form key
     */
    sendTestFormKey: 'sendTestForm',

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    _validateSaveEmail: function () {
        const emailData = this.state.workingResource;

        return !this.state.saving &&
            emailData &&
            emailData.status !== Status.COMPLETED &&
            emailData.name &&
            (emailData.stop_behavior == null || (emailData.stop_behavior === 'date' && emailData.stop_at) || emailData.stop_behavior === 'never');
    },

    _validateSendTestEmail: function () {
        const emailData = this.state.workingResource;

        return this._validateSaveEmail() &&
            emailData.from_name &&
            emailData.reply_to &&
            emailData.subject &&
            emailData.html &&
            emailData.text;
    },

    _validateSendEmail: function () {
        const emailData = this.state.workingResource;

        return this._validateSendTestEmail() &&
            emailData.cohort &&
            emailData.cohort.length === 1 &&
            (emailData.scheduling === Scheduling.ONCE_NOW
                || (emailData.scheduling === Scheduling.ONCE_LATER && emailData.start_at)
                || (emailData.scheduling === Scheduling.AS_MET && emailData.start_at &&
                    ((emailData.stop_behavior === 'date' && emailData.stop_at) || emailData.stop_behavior === 'never')));
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        const params = this.props.match.params || {};

        EmailMessagesStore.addChangeListener(this._onEmailChange);
        CohortsStore.addChangeListener(this._onCohortChange);
        FormStore.addChangeListener(this.bindResource);

        this.setState({
            params: params,
            resourceOperation: typeof params.id === 'undefined' ? 'create' : 'edit'
        }, function () {
            // An existing email
            if (this.state.resourceOperation === 'edit') {
                this.requestEmail(params.id);
            }
        });

        this.interval = setInterval(() => this.updatePreviewHtml(), 1000);
    },

    /**
     * Request email, if editing
     *
     * @param id
     */
    requestEmail: function (id) {
        this.resourceActions.getResource(id, this.getOptions);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        clearInterval(this.interval);

        EmailMessagesStore.removeChangeListener(this._onEmailChange);
        CohortsStore.removeChangeListener(this._onCohortChange);
        FormStore.removeChangeListener(this.bindResource);
    },

    /**
     * Handle change events
     */

    _onEmailChange: function () {
        this.setState({
            saving: false,
            workingResource: EmailMessagesStore.getResource(),
        }, function () {
            this.checkAndSendTestEmail();

            if (this.state.workingResource.cohort_id) {
                this.requestCohort(this.state.workingResource.cohort_id)
            }
        });
    },

    _onCohortChange: function () {
        this.setState((prevState) => ({
            workingResource: Object.assign({}, prevState.workingResource, {cohort: [CohortsStore.getResource()]})
        }), function () {
            FormStore.syncForm(this.formKey, this.state.workingResource);
        });
    },

    /**
     * Change handler for FormStore changes
     */
    bindResource: function () {
        this.setState({
            workingResource: FormStore.getResource(this.formKey),
        }, function () {
            this.forceUpdate(); // Yes, this is required in order to force the conditionally rendered stuff to be re-rendered.
        });
    },

    checkAndSendTestEmail: function () {
        if (this.state.savingForSendTest) {
            // Set the state that says we are no longer saving.
            this.setState({
                savingForSendTest: false,
            }, function () {
                // Send the test email now that it's saved.
                EmailMessagesApi.sendTest(this.state.workingResource.id, this.state.sendTestResource.recipient_email)

                // Reset the modal to the defaults.
                this.setState({
                    sendTestResource: {
                        recipient_email: this.defaultSendTestEmail
                    }
                })
            });
        }
    },

    /**
     * Action handlers
     *
     * @param action
     */
    handleAction: function (action) {
        switch (action) {
            case 'save':
                if (this._validateSaveEmail()) {
                    this.createOrUpdateResource(action);
                }
                break;
            case 'send-test':
                if (this._validateSendTestEmail()) {
                    this.setState({
                            openSendTestModal: true
                        }
                    );
                }
                break;
            case 'save-send':
                if (this._validateSendEmail()) {
                    this.createOrUpdateResource(action);
                }
                break;
            case 'goBack':
                this.transitionToLibrary()
                break;
        }
    },

    createOrUpdateResource: function (action) {
        if (this.state.saving) {
            return;
        }
        this.setState({
            saving: true
        }, function () {
            let emailData = _.cloneDeep(this.state.workingResource)

            if (emailData.cohort) {
                emailData.cohort_id = emailData.cohort[0].id;
                delete emailData.cohort;
            }

            switch (emailData.scheduling) {
                case Scheduling.ONCE_NOW:
                    emailData.start_at = new Date().toISOString();
                    emailData.stop_at = null;
                    break;
                case Scheduling.ONCE_LATER:
                    emailData.stop_at = null;
                    break;
                case Scheduling.AS_MET:
                    if (emailData.stop_behavior === 'never') {
                        emailData.stop_at = null;
                        delete emailData.stop_behavior;
                    }
                    break;
            }

            action === 'save' ? emailData.status = Status.DRAFT : emailData.status = Status.PENDING;

            if (!emailData.show_unsubscribe) {
                emailData.show_unsubscribe = 0;
            }
            if (!emailData.allow_duplicate_sends) {
                emailData.allow_duplicate_sends = 0;
            }

            if (typeof emailData.id === 'undefined') {
                this.resourceActions.createResource(emailData, this.sendOptions);
            } else {
                this.resourceActions.updateResource(emailData, this.sendOptions);
            }
        });
    },

    sendTest: function () {
        this.setState({
                savingForSendTest: true,
                sendTestResource: {
                    recipient_email: FormStore.getResource(this.sendTestFormKey)
                }
            }, function () {
                this.createOrUpdateResource('save');
            }
        );
    },

    /**
     * Direct the user back to the music library
     */
    transitionToLibrary: function () {
        this.props.history.push('/email-messages');
    },

    /**
     * Fire request action for cohorts
     */
    requestCohort: function (cohort_id) {
        this.cohortsResourceActions.getResource(cohort_id, this.getOptions);
    },

    updatePreviewHtml: function () {
        if (this.state.previewHtml !== this.state.workingResource.html) {
            this.setState({
                previewHtml: this.state.workingResource.html
            });
        }
    },

    /**
     * Close the send test email modal and reset the send test resource
     */
    closeModal: function () {
        this.setState({
            openSendTestModal: false,
        });
    },

    stopBehaviorOptions: [
        {
            label: 'Never',
            value: 'never'
        },
        {
            label: 'Specific Date',
            value: 'date'
        }
    ],

    render: function () {
        const disableSave = this._validateSaveEmail() ? null : 'disabled';
        const disableSendTest = this._validateSendTestEmail() ? null : 'disabled';
        const disableSend = this._validateSendEmail() ? null : 'disabled';
        const formDisabled = this.state.workingResource.status === Status.COMPLETED;

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row>
                        <Column grid="lg" size="6">
                            <h1 className="page-header">Manage Email Message</h1>
                        </Column>
                    </Row>
                    <Column grid="lg" size="12">
                        <div className="card card-default">
                            <div className="card-body">
                                <Row>
                                    <Column grid="lg" size="12">
                                        <Form key={this.formKey + this.state.workingResource.id} formKey={this.formKey}
                                              bindResource={this.state.workingResource}>
                                            <Row>
                                                <Column grid="lg" size="4">
                                                    <Form.Input fieldKey="name" type="text" label="Message Name"
                                                                placeholder="Email Message Name" limit={255}
                                                                validations="isLength:1:255"
                                                                required="true" disabled={formDisabled}/>
                                                </Column>
                                            </Row>

                                            <Row>
                                                <Column grid="lg" size="12">
                                                    <Section title="Message Content" defaultSection>
                                                        <Row>
                                                            <Column grid="lg" size="4">
                                                                <Form.Input fieldKey="from_name" type="text"
                                                                            label="From Name"
                                                                            placeholder="Your Name" limit={255}
                                                                            validations="isLength:1:255"
                                                                            disabled={formDisabled}/>
                                                            </Column>

                                                            <Column grid="lg" size="4">
                                                                <Form.Input fieldKey="reply_to" type="email"
                                                                            label="Reply-To Email"
                                                                            placeholder="your-email@example.com"
                                                                            limit={255}
                                                                            validations="isLength:1:255,isEmail"
                                                                            disabled={formDisabled}/>
                                                            </Column>

                                                            <Column grid="lg" size="4">
                                                                <Form.Input fieldKey="bcc" type="email"
                                                                            label="BCC Email"
                                                                            placeholder="bcc-email@example.com"
                                                                            limit={255}
                                                                            validations="isLength:1:255,isEmail"
                                                                            disabled={formDisabled}/>
                                                            </Column>
                                                        </Row>

                                                        <Row>
                                                            <Column grid="lg" size="6">
                                                                <Form.Input fieldKey="subject" type="text"
                                                                            label="Subject"
                                                                            placeholder="Email Subject" limit={255}
                                                                            validations="isLength:1:255"
                                                                            disabled={formDisabled}/>
                                                            </Column>

                                                            <Column grid="lg" size="6">
                                                                <Form.Input fieldKey="preview" type="text"
                                                                            label="Preview Text"
                                                                            placeholder="Email preview text" limit={255}
                                                                            validations="isLength:1:255"
                                                                            disabled={formDisabled}/>
                                                            </Column>
                                                        </Row>

                                                        <Row>
                                                            <Column grid="lg" size="6">
                                                                <Form.TextArea fieldKey="html" type="text"
                                                                               label="HTML Body"
                                                                               placeholder="<!DOCTYPE html>..."
                                                                               limit={16777215}
                                                                               validations="isLength:1:16777215"
                                                                               rows={30}
                                                                               disabled={formDisabled}/>
                                                            </Column>

                                                            <Column grid="lg" size="6">
                                                                <Label title="HTML Preview"/>
                                                                <br/>
                                                                <iframe key={"previewHtml"}
                                                                        style={{
                                                                            height: 600,
                                                                            width: '100%',
                                                                            overflow: 'scroll'
                                                                        }}
                                                                        srcDoc={this.state.previewHtml}/>
                                                            </Column>
                                                        </Row>

                                                        <Row>
                                                            <Column grid="lg" size="12">
                                                                <Form.TextArea fieldKey="text" type="text"
                                                                               label="HTML Plain Text Body"
                                                                               placeholder="Plain text email body"
                                                                               limit={16777215}
                                                                               validations="isLength:1:16777215"
                                                                               rows={10}
                                                                               disabled={formDisabled}/>
                                                            </Column>
                                                        </Row>

                                                        <Row>
                                                            <Column grid="lg" size="6">
                                                                <Form.Checkbox fieldKey="show_unsubscribe"
                                                                               label="Unsubscribe Link"
                                                                               options={[{
                                                                                   name: 'show_unsubscribe',
                                                                                   value: 1,
                                                                                   label: "Inject unsubscribe link into {{unsubscribelink}}"
                                                                               }]}
                                                                               disabled={formDisabled}/>
                                                            </Column>
                                                            <Column grid="lg" size="6">
                                                                <Form.Checkbox fieldKey="allow_duplicate_sends"
                                                                               label="Duplicate Deliveries"
                                                                               options={[{
                                                                                   name: 'allow_duplicate_sends',
                                                                                   value: 1,
                                                                                   label: "Allow sending this message multiple times"
                                                                               }]}
                                                                               disabled={formDisabled}/>
                                                            </Column>
                                                        </Row>
                                                    </Section>
                                                </Column>
                                            </Row>

                                            <Row>
                                                <Column grid="lg" size="12">
                                                    <Section title="Delivery Settings">
                                                        <Row>
                                                            <Column grid="lg" size="4">
                                                                <Form.TypeAheadInput fieldKey="cohort" source="remote"
                                                                                     resourceAction={this.cohortsTypeAheadResourceActions}
                                                                                     label="Target Cohort"
                                                                                     placeholder="Search cohorts.."
                                                                                     limit={1} fields={['name']}
                                                                                     options={{}}
                                                                                     disabled={formDisabled}/>
                                                            </Column>
                                                        </Row>
                                                        <Row>
                                                            <Column grid="lg" size="4">
                                                                <Form.SelectBox fieldKey="scheduling"
                                                                                label="Scheduling"
                                                                                options={Scheduling.SCHEDULING_OPTIONS}
                                                                                disabled={formDisabled}/>
                                                            </Column>
                                                            {this.state.workingResource.scheduling === Scheduling.AS_MET &&
                                                                <Column grid="lg" size="4">
                                                                    <Form.SelectBox fieldKey="stop_behavior"
                                                                                    label="End Behavior"
                                                                                    options={this.stopBehaviorOptions}
                                                                                    disabled={formDisabled}/>
                                                                </Column>
                                                            }
                                                        </Row>

                                                        {this.state.workingResource.scheduling && this.state.workingResource.scheduling !== Scheduling.ONCE_NOW &&
                                                            <Row>
                                                                <DayTimePicker fieldKey="start_at" label={"Start At"}
                                                                               disabled={formDisabled}/>
                                                                {this.state.workingResource.scheduling === Scheduling.AS_MET && this.state.workingResource.stop_behavior === 'date' &&
                                                                    <DayTimePicker fieldKey="stop_at" label={"End At"}
                                                                                   disabled={formDisabled}/>
                                                                }
                                                            </Row>
                                                        }
                                                    </Section>
                                                </Column>
                                            </Row>
                                        </Form>
                                    </Column>
                                </Row>
                                <Row classes="justify-content-end">
                                    <Button action="goBack" text="Go Back" handleAction={this.handleAction}/>
                                    <Button action="save" text="Save as Draft" handleAction={this.handleAction}
                                            mods={[disableSave]}/>
                                    <Button action="send-test" text="Save and Send Test"
                                            handleAction={this.handleAction}
                                            mods={[disableSendTest]}/>
                                    <Button action="save-send" text="Save and Start Sending"
                                            handleAction={this.handleAction}
                                            mods={['primary', disableSend]}/>
                                </Row>

                                {this.state.openSendTestModal && (
                                    <Modal openWhen={this.state.openSendTestModal}
                                           closeText="Close" saveText="Send Test"
                                           afterClose={this.closeModal}
                                           beforeSave={this.sendTest}
                                           afterSave={this.closeModal}>
                                        <Row>
                                            <Form key={this.sendTestFormKey} formKey={this.sendTestFormKey}
                                                  bindResource={this.state.sendTestResource}>
                                                <Row>
                                                    <Column grid="lg" size="8">
                                                        <Form.Input fieldKey="recipient_email" type="email"
                                                                    label="Recipient Email"
                                                                    placeholder="test@cardiocast.app" limit={255}
                                                                    validations="isLength:1:255"
                                                                    required="true"/>
                                                    </Column>
                                                </Row>
                                            </Form>
                                        </Row>
                                    </Modal>
                                )}
                            </div>
                        </div>
                    </Column>
                </div>
            </div>
        )
    },
});

module.exports = EmailManagement;
